export default function Testimonials() {
  const testimonials = [
    {
      name: 'Alex Thompson',
      role: 'Cloud Engineer at TechCorp',
      image: 'https://public.readdy.ai/ai/img_res/46c5e8fe9aeb813f83c0bde1ccd3557c.jpg',
      content: 'The Cloud Computing course transformed my career. Within 3 months of completing the program, I landed my dream job as a Cloud Engineer. The hands-on labs were invaluable!',
      rating: 5
    },
    {
      name: 'Priya Patel',
      role: 'DevOps Specialist at StartupHub',
      image: 'https://readdy.ai/api/search-image?query=professional%20female%20devops%20engineer%20confident%20smile%20smart%20casual%20clothing%20modern%20tech%20office%20natural%20lighting%20simple%20clean%20background%20corporate%20portrait%20indian%20descent&width=400&height=400&seq=testimonial-2&orientation=squarish',
      content: 'Best investment in my career! The DevOps training was comprehensive and practical. The instructors were always available to help, and the career support was exceptional.',
      rating: 5
    },
    {
      name: 'James Wilson',
      role: 'Security Analyst at SecureNet',
      image: 'https://readdy.ai/api/search-image?query=professional%20male%20cybersecurity%20analyst%20serious%20expression%20business%20attire%20modern%20office%20setting%20professional%20lighting%20clean%20backdrop%20corporate%20headshot%20african%20american&width=400&height=400&seq=testimonial-3&orientation=squarish',
      content: 'The Cybersecurity program exceeded my expectations. Real-world scenarios and expert guidance helped me pass my certification exams on the first try. Highly recommended!',
      rating: 5
    }
  ];

  return (
    <section className="py-24 bg-gray-950">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
            Success Stories
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Hear from our graduates who transformed their careers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-gray-900 rounded-xl p-8 border border-gray-800 hover:border-teal-500/50 transition-all duration-300"
            >
              <div className="flex gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-300 mb-8 leading-relaxed italic">
                "{testimonial.content}"
              </p>

              <div className="flex items-center gap-4">
                <div className="relative w-14 h-14 rounded-full overflow-hidden border-2 border-teal-500">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h4 className="text-white font-semibold">{testimonial.name}</h4>
                  <p className="text-gray-400 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}